import * as React from "react";

import { fontThemeClassForLocale } from "./localeToThemeClass";

export interface FontThemeProviderProps {
  /**
   * Locale string — the project emits short codes like `"en"`, `"ar"`, `"ur"`,
   * `"uk"`, `"zh"`. Lookup is a direct dictionary match against
   * `LOCALE_TO_THEME_CLASS`; unmapped or `undefined` values render the wrapper
   * with no class so descendants inherit the default `:root` tokens.
   */
  locale?: string;
  children: React.ReactNode;
}

/**
 * Renders a wrapper element carrying the locale-driven font theme class.
 * Vanilla-extract `--family_*` / `--weight_*` overrides cascade to every
 * descendant; siblings outside the wrapper keep the `:root` defaults.
 */
export const FontThemeProvider = ({
  locale,
  children,
}: FontThemeProviderProps) => {
  const themeClass = fontThemeClassForLocale(locale);
  return <div className={themeClass ?? undefined}>{children}</div>;
};
